<template>
  <v-card class="text-center">
    <v-card-title v-if="!gclasificacionesvisibles" class="grey lighten-4 change-font" primary-title>
      <div class="spinner-grow"></div>Cargando clasificaciones &#8230;
    </v-card-title>
    <v-card-title v-else class="grey lighten-4 change-font" primary-title>
      {{ titulo }}
      <span class="d-none d-md-block" style="white-space: pre-wrap;">&nbsp;(</span>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span class="d-none d-md-block" v-on="on">{{totalChilds}}*</span>
        </template>
        <span>Para el reporte del indicador F.E.7 se generó un indicador para cada órgano de control, por lo cual se hace seguimiento a 100 indicadores étnicos.</span>
      </v-tooltip>
        <span class="d-none d-md-block" style="white-space: pre-wrap;">&nbsp;indicadores)</span>
    </v-card-title>
    <v-card-text>
      <v-container  v-if="gclasificacionesvisibles.length>0"  grid-list-xl>
        <v-layout wrap>
          <p  class="aclaratoria">Conozca el avance en la implementación del Acuerdo Final de Paz según el enfoque poblacional y territorial contenido en el Acuerdo. Además, incluye las metas trazadoras para el cumplimiento de los objetivos estratégicos estipuladas en el Plan Marco de Implementación.</p>
          <v-flex xs12 md6 lg3 v-for="(item, index) in gclasificacionesvisibles" :key="index">
            <a @click="navegar(item.idclasificacion)">
              <v-progress-linear
                style
                :active="true"
                :background-opacity="0.18"
                :buffer-value="100"
                :height="40"
                :value="item.porcentajeAvance"
                :color="item.color"
                :to="linkPath + '/' + item.idclasificacion"
              >
                <template v-slot="{ value }">
                  <strong
                    style=" font-size: large"
                  >{{ Intl.NumberFormat("es-CO", {minimumFractionDigits: 1}).format(value ) + " %" }}</strong>
                </template>
              </v-progress-linear>
              <div class="clasificacion-nombre">{{ item.nombre }}</div>
              <div style="white-space: pre-wrap;"
                class="clasificacion-indicadores"
                v-if="'(' + item.conteoIndicadores + ' indicadores)'"
              >{{ '(' + item.conteoIndicadores + ' indicadores)' }}</div>
            </a>
          </v-flex>
        </v-layout>
      </v-container>
      <p v-else>{{gnodata}}</p>      
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    titulo: {
      type: String,
      required: false,
      default: "Avance por punto"
    },
    subtitulo: {
      type: String,
      required: false,
      default: "Haga clic para observar los pilares respectivos"
    },
    linkPath: {
      type: String,
      required: false,
      default: "/avance/clasificacion"
    }
  },
  created() {
    this.get_clasificacionperiodo({
      params: {
        periodoId: this.gperiodo
      }
    });
  },
  mounted() {},
  updated() {},
  computed: {
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters( ["gclasificacionesvisibles"] ),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    totalChilds() {
      var t = 0;
      this.gclasificacionesvisibles.forEach(element => {
        t += element.conteoIndicadores;
      });
      return t;
    },
    total() {
      return this.gclasificacionesvisibles.length;
    }
  },
  methods: {
    ...mapActions(["get_clasificacionperiodo"]),
    navegar(idclasificacion) {
     localStorage.removeItem("filtroclasificacion");
      this.$router.push({
        path: this.linkPath + "/" + idclasificacion
      });
    }
  },
  watch: {
    gperiodo: function() {
      this.get_clasificacionperiodo({
        params: {
          periodoId: this.gperiodo
        }
      });
    }
  }
};
</script>
